import { Component, OnInit, Input } from '@angular/core';
import { Timezone } from 'src/app/core/_helpers/timezones';
import { AuthenticationService } from 'src/app/core/authentication/Authentication.service';
import { User } from '../../../core/authentication/user';
// import { AngularFireStorage } from '@angular/fire/storage';
import { Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { Language } from 'src/app/core/_helpers/Language';
import * as firebase from 'firebase/app';
import { stringify } from '@angular/compiler/src/util';

class ImageSnippet {
  constructor(public src: string, public file: File) { }
}

@Component({
  selector: 'app-profile-settings',
  templateUrl: './profile-settings.component.html',
  styleUrls: ['./profile-settings.component.scss']
})
export class ProfileSettingsComponent implements OnInit {

  selectedFile: ImageSnippet;
  file: File;

  constructor(public auth: AuthenticationService,
    private _snackBar: MatSnackBar, private languaje: Language) { }

  @Input() public lenguaje: string;
  public Email: string;
  public Token: string;
  public isLogin: boolean;
  public nombreUsuario: string;
  dataTime = new Timezone().getTimezone();
  private uid: string;
  public photoURL: string;
  uploadPercent: Observable<number>;
  urlImage: Observable<string>;
  action: number = 1;
  // selectedFile: File;


  ngOnInit() {

    this.perfilUser();
    this.lenguajeIni();
  }

  onFileChanged(imageInput: any) {
    this.file = imageInput.files[0];
    const reader = new FileReader();

    reader.addEventListener('load', (event: any) => {

      this.selectedFile = new ImageSnippet(event.target.result, this.file);

      console.log(this.selectedFile);
      this.photoURL = this.selectedFile.src;
    });

    reader.readAsDataURL(this.file);
  }

  perfilUser() {
    const id = localStorage.getItem('uid');
    firebase.database().ref('users/' + id).once('value').then((snapshot) => {
      var username = (snapshot.val() && snapshot.val() != null) || 'Anonymous';
      if (snapshot.val() != null) {
        this.isLogin = true;
        this.nombreUsuario = snapshot.val().displayName;
        this.Email = snapshot.val().email;
        this.uid = snapshot.val().uid;
      } else {
        this.isLogin = false;
      }
    });
    /* });
   this.auth.GetUserProfile(id).subscribe(response => {
      if (response) {
        //console.log(response);
        this.isLogin = true;
        this.nombreUsuario = response[0]['displayName'];
        this.Email = response[0]['email'];
        this.uid = response['uid'];
      } else {
        this.isLogin = false;
      }
    });*/
  }

  onSubmit() {
    const data: User = {
      uid: this.uid,
      email: this.Email,
      photoURL: this.photoURL,
      displayName: this.nombreUsuario,
    };

    this.auth.updateUser(data).then((succes) => {
      // console.log({ html: 'Se ha cambiado con exito la contraseña' });
      this._snackBar.open('Se ha actualizado el nombre de perfil', 'Cerrar', {
        duration: 3000
      });

    }, (error) => {

      console.log({ html: 'Error:' + error.message });
    });
  }

  changePassword() {
    this.action = 2;
  }

  resultComp($event) {
    this.action = $event;
  }

  lenguajeIni() {
    this.languaje.IniLenguaje(this.lenguaje);
  }
}
